import EnfinityFam from "@/assets/svg/adcelerate/enfinity-family.svg";
import BadgeCheck from "@/assets/svg/badge-check-black.svg";
import Youtube from "@/assets/svg/yt1.svg";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { motion, useAnimation } from "framer-motion";
import { useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";
import { useLocation } from "react-router-dom";

function ScrollFillBorder({ children }) {
  const controls = useAnimation();
  const ref = useRef(null);
  const [inViewRef, inView] = useInView({
    rootMargin: "-40% 0px -40% 0px",
    triggerOnce: true,
  });

  // Combine refs
  const setRefs = (node) => {
    ref.current = node;
    inViewRef(node);
  };

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [inView, controls]);

  return (
    <div ref={setRefs} className="relative pl-6">
      <motion.div
        initial={{ height: 0 }}
        animate={controls}
        variants={{
          visible: {
            height: "100%",
            transition: {
              duration: 6,
              ease: [0.25, 0.8, 0.25, 1],
            },
          },
        }}
        className="absolute left-0 top-0 w-[3px] bg-primary"
      />
      <div className="space-y-10">{children}</div>
    </div>
  );
}

export default function WhoWeAre() {
  const { ref: sectionRef, isVisible: sectionVisible } = useScrollReveal();

  const location = useLocation();

  return (
    <>
      <div
        ref={sectionRef}
        className={`flex flex-col justify-between py-20 items-center w-[90%] mx-auto gap-12 4xl:max-w-[100rem] 4xl:mx-auto ${
          sectionVisible ? "bounce-up" : ""
        }
`}
      >
        <div className="flex flex-col gap-8 justify-center items-center w-full">
          <div className="flex gap-3 items-center justify-center lg:justify-end hero-reveal">
            <img
              src={Youtube}
              className="w-14 md:w-14 h-14 md:h-14"
              alt="YouTube"
            />
            <div className="border-l-2 border-gray-400 h-12"></div>
            <div className="text-blck md:pl-2 text-left">
              <p className="flex gap-2 text-nowrap">
                Official YouTube Certified
                <img src={BadgeCheck} alt="Badge" />
              </p>
              <p>Creator Service Provider</p>
            </div>
          </div>
          <img
            src={EnfinityFam}
            className="lg:h-[480px] mx-auto"
            alt="Creators"
          />
        </div>
        <div className="space-y-6 mx-auto text-center">
          <h1 className="text-primary text-4xl lg:text-6xl font-bold adce-hero uppercase">
            Who we are
          </h1>
          <p className="max-w-lg">
            Adcelerate is an official distribution brand of Enfinity, a leading
            content monetization company & digital rights technology developer
            with over 3,500 creators, 100 employees and $70-million dollars in
            top-line revenue.
          </p>
        </div>
      </div>
      {location.pathname === "/about-us" && (
        <div className="py-10 px-10 md:px-28 4xl:px-16 4xl:max-w-[100rem] 4xl:mx-auto">
          <ScrollFillBorder>
            <div className="p-10 pr-0 md:p-16 space-y-6 max-w-2xl">
              <h1 className="text-5xl font-bold adce-hero text-primary">
                Leadership
              </h1>
              <p className="text-lg">
                Our leadership team is compromised of creator economy veterans —
                with over 30 combined years of experience being brought to the
                table; with a substantial executive background on YouTube and
                Facebook.
              </p>
            </div>
            <div className="p-10 pr-0 md:p-16 space-y-6 max-w-2xl">
              <h1 className="text-5xl font-bold adce-hero text-primary">
                Ethos
              </h1>
              <p className="text-lg">
                We’re results oriented. In the creator economy, there is a lot
                of noise and garbage. We cut to the chase and serve our clients
                by increasing the numbers on their bottom line monthly revenues
                — and we change lives.
              </p>
            </div>
            <div className="p-10 pr-0 md:p-16 space-y-6 max-w-2xl">
              <h1 className="text-5xl font-bold adce-hero text-primary">
                Locations
              </h1>
              <p className="text-lg">
                Adcelerate has teams and/or offices in the United States, Dubai,
                UAE and Manila, Philippines. Our legal headquarters is in Hong
                Kong.
              </p>
            </div>
          </ScrollFillBorder>
        </div>
      )}
    </>
  );
}
